import { createContext, useContext } from 'react';
import emptyFunction from 'react-utils/emptyFunction';
export const defaultDialogContext = {
  use: 'default',
  headerCallback: emptyFunction,
  inDialog: false
};
export const DialogContext = /*#__PURE__*/createContext(defaultDialogContext);
const {
  Provider
} = DialogContext;
export { Provider as DialogContextProvider };
export const useDialogContext = () => {
  const context = useContext(DialogContext);
  return context;
};